import React, { useRef, useImperativeHandle, useState } from "react";
import clsx from "clsx";
import { v4 as uuid } from "uuid";
import { FormControlLabel, Checkbox, Box } from "@curves/ui-base";

const NoticeCard = React.forwardRef(({ img, title, noticeData, className, defaultValue = false, readOnly, WarnComponent, required }, ref) => {
	const checkRef = useRef(null);
	const [errorText, setErrorText] = useState(null);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => checkRef.current,
			isError: () => {
				let isChecked = checkRef.current.checked;
				if (required && !isChecked) setErrorText("請先閱讀內容，並勾選以確認");
				else {
                    setErrorText(null);
                    isChecked = true
                }
				return !isChecked;
			},
		}),
        // eslint-disable-next-line
		[required]
	);

	return (
		<React.Fragment>
			<Box className={clsx(className, "notice-card")}>
				<Box className="notice-card-img">{img && <img className="img-fluid" src={img} alt="title" />}</Box>
				<Box className="notice-card-content">
					<FormControlLabel
						className="control"
						control={<Checkbox inputRef={el => (checkRef.current = el)} defaultChecked={defaultValue} />}
						label={title}
						readOnly={readOnly}
					/>
					{errorText && <Box className="text-error">{errorText}</Box>}
					<Box component="ul" className="list">
						{noticeData.map(item => (
							<Box component="li" key={uuid()} className="list-item">
								{item}
							</Box>
						))}
					</Box>
				</Box>
			</Box>
			{WarnComponent && <WarnComponent />}
		</React.Fragment>
	);
});

export default NoticeCard;
